import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// tslint:disable-next-line:no-console
console.info('Frontoffice - SBB Gouda Keramiek - v2025.10.0');

platformBrowserDynamic().bootstrapModule(AppModule);
